// HOW TO: Adding a brand
//  - Import the logo
//  - Add an entry to the LICENSE_BRANDS var, where the key is the `branding` license value (lower)
//  - If it's a story brand, add an entry to STORY_BRANDS (lower)
//  ALL VALUES WILL DEFAULT TO AMIRA VALUES UNLESS THEY ARE SPECIFICALLY OVERIDDEN

import { initi18n } from "../i18n/i18n";

// Logos
import AmiraLogo from "../images/partner-logos/hmh_logo.png";
import EPSLogo from "../images/partner-logos/EPS.png";
import EPSStandaloneLogo from "../images/partner-logos/EPS-Standalone.png";
import HighlightLogo from '../images/partner-logos/highlights_logo.svg';
import NweaLogo from '../images/partner-logos/nwea_logo.png';

// Standard Practice Logos
import AmiraStandardPracticeIcon from "../images/icons/AmiraStandardPractice.png";

// Skill Scaffold Logos
import AmiraSkillScaffoldIcon from "../images/icons/AmiraSkillScaffold.svg";
import { defaultCurriculumDisplayName } from "../components/Reports/containers/ReportSettings/SelectSkillsCurriculum/defaultCurriculumConfig";

// Badging Certificate Full Color Images

// Amira
import AmiraCertPalEn from 'Assets/badging/certs/amira/Cert_Pal_EN.jpg';
import AmiraCertBuddyEn from 'Assets/badging/certs/amira/Cert_Buddy_EN.jpg';
import AmiraCertRangerEn from 'Assets/badging/certs/amira/Cert_Ranger_EN.jpg';
import AmiraCertTitanEn from 'Assets/badging/certs/amira/Cert_Titan_EN.jpg';
import AmiraCertGuruEn from 'Assets/badging/certs/amira/Cert_Guru_EN.jpg';
import AmiraCertWizardEn from 'Assets/badging/certs/amira/Cert_Wizard_EN.jpg';

import AmiraCertPalEs from 'Assets/badging/certs/amira/Cert_Pal_ES.jpg';
import AmiraCertBuddyEs from 'Assets/badging/certs/amira/Cert_Buddy_ES.jpg';
import AmiraCertRangerEs from 'Assets/badging/certs/amira/Cert_Ranger_ES.jpg';
import AmiraCertTitanEs from 'Assets/badging/certs/amira/Cert_Titan_ES.jpg';
import AmiraCertGuruEs from 'Assets/badging/certs/amira/Cert_Guru_ES.jpg';
import AmiraCertWizardEs from 'Assets/badging/certs/amira/Cert_Wizard_ES.jpg';

// Maya
import MayaCertPalEn from 'Assets/badging/certs/maya/Cert_Pal_EN.png';
import MayaCertBuddyEn from 'Assets/badging/certs/maya/Cert_Buddy_EN.png';
import MayaCertRangerEn from 'Assets/badging/certs/maya/Cert_Ranger_EN.png';
import MayaCertTitanEn from 'Assets/badging/certs/maya/Cert_Titan_EN.png';
import MayaCertGuruEn from 'Assets/badging/certs/maya/Cert_Guru_EN.png';
import MayaCertWizardEn from 'Assets/badging/certs/maya/Cert_Wizard_EN.png';

import MayaCertPalEs from 'Assets/badging/certs/maya/Cert_Pal_ES.png';
import MayaCertBuddyEs from 'Assets/badging/certs/maya/Cert_Buddy_ES.png';
import MayaCertRangerEs from 'Assets/badging/certs/maya/Cert_Ranger_ES.png';
import MayaCertTitanEs from 'Assets/badging/certs/maya/Cert_Titan_ES.png';
import MayaCertGuruEs from 'Assets/badging/certs/maya/Cert_Guru_ES.png';
import MayaCertWizardEs from 'Assets/badging/certs/maya/Cert_Wizard_ES.png';

// Badging Certificate Monochrome Images

//Amira
import AmiraBwCertPalEn from 'Assets/badging/certs/amira/BWCert_Pal_EN.jpg';
import AmiraBwCertBuddyEn from 'Assets/badging/certs/amira/BWCert_Buddy_EN.jpg';
import AmiraBwCertRangerEn from 'Assets/badging/certs/amira/BWCert_Ranger_EN.jpg';
import AmiraBwCertTitanEn from 'Assets/badging/certs/amira/BWCert_Titan_EN.jpg';
import AmiraBwCertGuruEn from 'Assets/badging/certs/amira/BWCert_Guru_EN.jpg';
import AmiraBwCertWizardEn from 'Assets/badging/certs/amira/BWCert_Wizard_EN.jpg';

import AmiraBwCertPalEs from 'Assets/badging/certs/amira/BWCert_Pal_ES.jpg';
import AmiraBwCertBuddyEs from 'Assets/badging/certs/amira/BWCert_Buddy_ES.jpg';
import AmiraBwCertRangerEs from 'Assets/badging/certs/amira/BWCert_Ranger_ES.jpg';
import AmiraBwCertTitanEs from 'Assets/badging/certs/amira/BWCert_Titan_ES.jpg';
import AmiraBwCertGuruEs from 'Assets/badging/certs/amira/BWCert_Guru_ES.jpg';
import AmiraBwCertWizardEs from 'Assets/badging/certs/amira/BWCert_Wizard_ES.jpg';

// Maya
import MayaBwCertPalEn from 'Assets/badging/certs/maya/BWCert_Pal_EN.jpg';
import MayaBwCertBuddyEn from 'Assets/badging/certs/maya/BWCert_Buddy_EN.jpg';
import MayaBwCertRangerEn from 'Assets/badging/certs/maya/BWCert_Ranger_EN.jpg';
import MayaBwCertTitanEn from 'Assets/badging/certs/maya/BWCert_Titan_EN.jpg';
import MayaBwCertGuruEn from 'Assets/badging/certs/maya/BWCert_Guru_EN.jpg';
import MayaBwCertWizardEn from 'Assets/badging/certs/maya/BWCert_Wizard_EN.jpg';

import MayaBwCertPalEs from 'Assets/badging/certs/maya/BWCert_Pal_ES.jpg';
import MayaBwCertBuddyEs from 'Assets/badging/certs/maya/BWCert_Buddy_ES.jpg';
import MayaBwCertRangerEs from 'Assets/badging/certs/maya/BWCert_Ranger_ES.jpg';
import MayaBwCertTitanEs from 'Assets/badging/certs/maya/BWCert_Titan_ES.jpg';
import MayaBwCertGuruEs from 'Assets/badging/certs/maya/BWCert_Guru_ES.jpg';
import MayaBwCertWizardEs from 'Assets/badging/certs/maya/BWCert_Wizard_ES.jpg';



// The list of Brands.  This is used to search through the story tags
const STORY_BRANDS = [
  'eps_spire',
  'capstone',
  'kiddom',
  'highlights',
  'hmh',
  'eps-standalone-reading-assistant',
  'nwea-map-tutor'
]

const BRANDS_DATA = {
  amira: {
    appName: 'Amira',
    badgingCertificates: {
      EN_US: {
        color: {
          PAL: AmiraCertPalEn,
          BUDDY: AmiraCertBuddyEn,
          RANGER: AmiraCertRangerEn,
          TITAN: AmiraCertTitanEn,
          GURU: AmiraCertGuruEn,
          WIZARD: AmiraCertWizardEn,
        },
        monochrome: {
          PAL: AmiraBwCertPalEn,
          BUDDY: AmiraBwCertBuddyEn,
          RANGER: AmiraBwCertRangerEn,
          TITAN: AmiraBwCertTitanEn,
          GURU: AmiraBwCertGuruEn,
          WIZARD: AmiraBwCertWizardEn,
        }
      },
      ES_MX: {
        color: {
          PAL: AmiraCertPalEs,
          BUDDY: AmiraCertBuddyEs,
          RANGER: AmiraCertRangerEs,
          TITAN: AmiraCertTitanEs,
          GURU: AmiraCertGuruEs,
          WIZARD: AmiraCertWizardEs,
        },
        monochrome: {
          PAL: AmiraBwCertPalEs,
          BUDDY: AmiraBwCertBuddyEs,
          RANGER: AmiraBwCertRangerEs,
          TITAN: AmiraBwCertTitanEs,
          GURU: AmiraBwCertGuruEs,
          WIZARD: AmiraBwCertWizardEs,
        }
      }
    },
    companyName: 'Amira Learning',
    copyright: `Copyright © 2018-${new Date().getFullYear()} Amira Learning, Inc. All rights reserved. Terms of Use. Privacy Policy.`,
    defaultCurriculumName: defaultCurriculumDisplayName,
    footer: 'The first Intelligent Reading Assistant that listens, assesses & coaches, Amira accelerates reading mastery.',
    hiddenReports: [],
    logo: AmiraLogo,
    logoAltText: 'Aira logo',
    skillScaffoldIcon: AmiraSkillScaffoldIcon,
    standardPracticeIcon: AmiraStandardPracticeIcon,
    tutorName: 'Amira',
    tutorSkin: 'Amira',
  },
  eps: {
    appName: 'Reading Assistant',
    companyName: 'EPS',
    copyright: '© EPS Operations, LLC. All rights reserved.',
    defaultCurriculumName: 'EPS Default',
    footer: 'The first Intelligent Reading Assistant that listens, assesses & coaches, Amira accelerates reading mastery.',
    logo: EPSStandaloneLogo,
    logoAltText: 'Reading Assistant logo',
    supportURL: 'https://epscurriculumsupport.wikipage.io/c/234389550/reading+assistant',
  },
  ["eps-standalone-reading-assistant"]: {
    appName: 'Reading Assistant',
    companyName: 'EPS',
    copyright: '© EPS Operations, LLC. All rights reserved.',
    footer: 'The first Intelligent Reading Assistant that listens, assesses & coaches.',
    logo: EPSStandaloneLogo,
    logoAltText: 'Reading Assistant logo',
  },
  highlights: {
    copyright: 'Copyright © Highlights for Children, Inc., Columbus Ohio. All rights reserved.',
    footer: 'The first Intelligent Reading Assistant that listens, assesses & coaches, Amira accelerates reading mastery.',
    logo: HighlightLogo,
    logoAltText: 'Highlights logo',
  },
  hmh: {
    copyright: 'Copyright © by Houghton Mifflin Harcourt Publishing Company. All rights reserved.',
    footer: 'The first Intelligent Reading Assistant that listens, assesses & coaches, Amira accelerates reading mastery.',
  },
  ['nwea-map-tutor']: {
    appName: 'Map Reading Fluency',
    badgingCertificates: {
      EN_US: {
        color: {
          PAL: MayaCertPalEn,
          BUDDY: MayaCertBuddyEn,
          RANGER: MayaCertRangerEn,
          TITAN: MayaCertTitanEn,
          GURU: MayaCertGuruEn,
          WIZARD: MayaCertWizardEn,
        },
        monochrome: {
          PAL: MayaBwCertPalEn,
          BUDDY: MayaBwCertBuddyEn,
          RANGER: MayaBwCertRangerEn,
          TITAN: MayaBwCertTitanEn,
          GURU: MayaBwCertGuruEn,
          WIZARD: MayaBwCertWizardEn,
        }
      },
      ES_MX: {
        color: {
          PAL: MayaCertPalEs,
          BUDDY: MayaCertBuddyEs,
          RANGER: MayaCertRangerEs,
          TITAN: MayaCertTitanEs,
          GURU: MayaCertGuruEs,
          WIZARD: MayaCertWizardEs,
        },
        monochrome: {
          PAL: MayaBwCertPalEs,
          BUDDY: MayaBwCertBuddyEs,
          RANGER: MayaBwCertRangerEs,
          TITAN: MayaBwCertTitanEs,
          GURU: MayaBwCertGuruEs,
          WIZARD: MayaBwCertWizardEs,
        }
      }
    },
    companyName: 'NWEA',
    copyright: `© NWEA ${new Date().getFullYear()}. MAP is a registered trademark. NWEA, MAP Growth, MAP Skills, and MAP Reading Fluency are trademarks of NWEA in the U.S. and in other countries. This system contains confidential information that may be subject to applicable federal and state law. By accessing this system, you shall comply with such applicable laws, the terms and conditions of your agreement with NWEA, and your entity’s policies regarding the use, transmission and handling of such confidential information.`,
    footer: 'The first Intelligent Reading Tutor that listens, assesses & coaches.',
    hiddenReports: [
      'benchmark',
      'classprogress',
      'dyslexiarisk',
      'parent',
      'readingrope',
    ],
    reviewActivityPracticeOnly: true,
    trackingReportConfig: {
        benchmark: false,
        progressMonitoring: false,
        practice: true,
        districtAssessment: false,
        calibration: false,
        unassign: false
    },
    logo: NweaLogo,
    logoAltText: 'Nwea logo',
    tutorName: 'Maya',
    tutorSkin: 'Maya',
    hideAssessmentPrompt: true,
  },
}

export function SetBranding(branding = null) {
  localStorage.setItem('branding', branding);
  // Set these for direct .html (sessionEnd.html, etc) screen have access without react
  localStorage.setItem('brandedLogo', GetBrandedLogo());
  localStorage.setItem('brandedLogoAltText', GetBrandedLogoAltText());
  initi18n(GetBrandedAppName());
}

function getAndFormatBranding(rawBranding = null) {
  let branding = rawBranding;
  if (!branding) {
    branding = localStorage.getItem('branding');
  }
  if (branding) {
    branding = branding.toLowerCase();
  }

  return branding;
}

export function GetBrandedAppName() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].appName ? BRANDS_DATA[branding].appName : BRANDS_DATA.amira.appName;
}

export function GetBrandedBadgingCertificate(level, locale, monochrome) {
  const branding = getAndFormatBranding();
  const colorOrMonochrome = monochrome ? 'monochrome' : 'color';
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].badgingCertificates ? BRANDS_DATA[branding].badgingCertificates[locale][colorOrMonochrome][level] : BRANDS_DATA.amira.badgingCertificates[locale][colorOrMonochrome][level];
}

export function GetBrandedCompanyName() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].companyName ? BRANDS_DATA[branding].companyName : BRANDS_DATA.amira.companyName;
}

export function GetBrandedCopyright(rawBranding) {
  const branding = getAndFormatBranding(rawBranding);
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].copyright ? BRANDS_DATA[branding].copyright : BRANDS_DATA.amira.copyright;
}

export function GetBrandedCurriculumName(rawBranding) {
  const branding = getAndFormatBranding(rawBranding);
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].defaultCurriculumName ? BRANDS_DATA[branding].defaultCurriculumName : BRANDS_DATA.amira.defaultCurriculumName;
}

export function GetBrandedFooter(rawBranding) {
  const branding = getAndFormatBranding(rawBranding);
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].footer ? BRANDS_DATA[branding].footer : BRANDS_DATA.amira.footer;
}

export function GetBrandedHiddenReports(rawBranding) {
  const branding = getAndFormatBranding(rawBranding);
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].hiddenReports ? BRANDS_DATA[branding].hiddenReports : BRANDS_DATA.amira.hiddenReports;
}

export function GetBrandedLogo(rawBranding) {
  const branding = getAndFormatBranding(rawBranding);
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].logo ? BRANDS_DATA[branding].logo : BRANDS_DATA.amira.logo;
}

export function GetBrandedLogoAltText(rawBranding) {
  const branding = getAndFormatBranding(rawBranding);
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].logoAltText ? BRANDS_DATA[branding].logoAltText : BRANDS_DATA.amira.logoAltText;
}

export function GetBrandedSkillScaffoldIcon() {
  const brand = BRANDS_DATA[getAndFormatBranding()];
  const skillScaffoldIcon = brand ? brand.skillScaffoldIcon : null;
  if (!skillScaffoldIcon) {
    return BRANDS_DATA.amira.skillScaffoldIcon;
  }
  return skillScaffoldIcon;
}

// Further implementation thoughts:
// Do we like this way better than other getters here? it's more efficient maybe, only accesses needed values once instead of BRANDS_DATA[branding].X multiple times
export function GetBrandedStandardPracticeIcon() {
  const brand = BRANDS_DATA[getAndFormatBranding()];
  const standardPracticeIcon = brand ? brand.standardPracticeIcon : null;
  if (!standardPracticeIcon) {
    return BRANDS_DATA.amira.standardPracticeIcon;
  }
  return standardPracticeIcon;
}

// Get the string name of the branded tutor character
export function GetBrandedTutorName() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].tutorName ? BRANDS_DATA[branding].tutorName : BRANDS_DATA.amira.tutorName;
}

// Get the string name of the branded tutor character's Spine skin
export function GetBrandedTutorSkin() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].tutorSkin ? BRANDS_DATA[branding].tutorSkin : BRANDS_DATA.amira.tutorSkin;
}

export function GetTrackingReportConfig() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].trackingReportConfig;
}

// Tags for partners are ex: CP_EPS_*, so we need to loop through and check if each tag includes the brand.
//   Then we can get the right data.
export function GetStoryBranding(storyTags) {
  let brand = null;
  storyTags.forEach(tag => {
    STORY_BRANDS.forEach(storyBrand => {
      if (tag && tag.toLocaleLowerCase().includes(storyBrand)) {
        brand = BRANDS_DATA[storyBrand];
        return;
      }
    })

    if (brand) {
      return;
    }
  })

  return brand;
}

export function GetBrandedSupportURL() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].supportURL ? BRANDS_DATA[branding].supportURL : null;
}

export function GetBrandedReviewActivityPracticeOnly() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].reviewActivityPracticeOnly ? BRANDS_DATA[branding].reviewActivityPracticeOnly : null;
}

export function GetBrandedHideAssessmentPrompt() {
  const branding = getAndFormatBranding();
  return branding && BRANDS_DATA[branding] && BRANDS_DATA[branding].hideAssessmentPrompt ? true : false;
}